import { Hidden }                               from "@material-ui/core";
import * as React                               from "react";
import { SFC }                                  from "react";
import { DropdownItemProps, Form, Icon, Popup } from "semantic-ui-react";
import ReservationSetting                       from "../../../../domain/reservation/ReservationSetting";
import ReservationTimeType                      from "../../../../domain/reservation/ReservationTimeType";
import ReservationTimeTypeClass                 from "../../../../domain/reservation/ReservationTimeTypeClass";

interface Props {
  label: string;
  reservationSetting: ReservationSetting;
  onChange: (value: ReservationTimeType) => void;
}

const ReservationTimeTypeSelector: SFC<Props> = (props: Props) => {
  const {label, reservationSetting} = props;

  const options: DropdownItemProps[] = [
    {
      key: ReservationTimeType.MINUTE_15,
      text: "15分",
      value: ReservationTimeType.MINUTE_15
    },
    {
      key: ReservationTimeType.MINUTE_30,
      text: "30分",
      value: ReservationTimeType.MINUTE_30
    },
    {
      key: ReservationTimeType.MINUTE_60,
      text: "60分",
      value: ReservationTimeType.MINUTE_60
    },
    {
      key: ReservationTimeType.MINUTE_90,
      text: "90分",
      value: ReservationTimeType.MINUTE_90
    },
    {
      key: ReservationTimeType.MINUTE_120,
      text: "120分",
      value: ReservationTimeType.MINUTE_120
    },
  ];
  return (
    <>
      <Hidden smDown={ true }>
        <Form style={ {marginBottom: "1rem", maxWidth: 200} }>
          <Form.Field>
            <label>
              { label }
              <Popup
                trigger={ <Icon name="help circle" style={ {marginLeft: "0.5rem"} }/> }
                size="mini"
              >
                １回の予約時間を設定します。
              </Popup>
            </label>
            <Form.Dropdown
              onChange={ (event, data) => props.onChange(ReservationTimeTypeClass.of(data.value)) }
              selection={ true }
              options={ options }
              value={ reservationSetting.timeType.value }
            />
          </Form.Field>
        </Form>
      </Hidden>

      <Hidden mdUp={ true }>
        <Form style={ {marginBottom: "1rem"} }>
          <Form.Field>
            <label>
              { label }
              <Popup
                trigger={ <Icon name="help circle" style={ {marginLeft: "0.5rem"} }/> }
                size="mini"
              >
                １回の予約時間を設定します。
              </Popup>
            </label>
            <Form.Dropdown
              onChange={ (event, data) => props.onChange(ReservationTimeTypeClass.of(data.value)) }
              selection={ true }
              options={ options }
              value={ reservationSetting.timeType.value }
            />
          </Form.Field>
        </Form>
      </Hidden>
    </>
  )
};

export default ReservationTimeTypeSelector;
